<template>
  <div class="row no-gutters catalog catalog-nav-component cnc">
    <div class="col-3 cnc__nav">
      <catalog-menu-listing :current-catalog="currentCatalog" />
    </div>
    <div class="col-9">
      <template v-if="IsNotNullOrUndefined(this,'CatalogRoot')">
        <catalog-preview
          v-for="category in CatalogRoot"
          v-show="currentCatalog.id == category.Id"
          :key="category.Id"
          ref="catalogPreview"
          :category="category"
        />
      </template>
      <div class="cat-shop">
        <router-link :to="currentCatalog.link" class="csc__shop-all-link hmmc__menu-item">
          Shop All {{ currentCatalog.name }} &gt;&gt;
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import CatalogMenuListing from "@/components/Catalog/MegaMenu/CatalogMenuListing"
  import CatalogPreview from "@/components/Catalog/MegaMenu/CatalogPreview"
  import { mapGetters }       from "vuex"

  export default {
    components: {
      CatalogMenuListing,
      CatalogPreview
    },
    data: function() {
      return {
        currentCatalog: {
          name: "",
          link: "",
          id: undefined
        }
      }
    },
    computed: {
      ...mapGetters(["CatalogRoot"])
    },
    watch: {
      CatalogRoot: function (val) {
      }
    }
  }

</script>
<style lang="scss">
.cnc__nav{
  a {
    padding-left: 5px;
    font-weight: normal;
    text-shadow: none;
    color: $brand;
    &:hover{
      color: #fff;
      background-color: $brand;
      text-decoration: none;
      font-weight: normal;
    }
  }
}
.csc__shop-all-link:hover {
  color: #000;
  background: transparent;
}
</style>
